import React from "react";
import styles from "./TextInput.module.scss";

export interface Props {
    /** DOM attribute name */
    name: string;
    /** Shown on focus */
    help: string;
    /** Defaults to text */
    type?: string;
    /** Initial DOM attribute value */
    defaultValue?: string;
    /** DOM attribute placeholder */
    placeholder?: string;
    /** Flag to set DOM attribute disabled */
    disabled?: boolean;
    /** Flag to set DOM attribute required (enforced by modern browsers, ignored by others) */
    required?: boolean;
    /** Flag to set DOM attribute autocomplete="off" */
    nocomplete?: boolean;
    /** Flag to set DOM attribute autoCorrect="off" */
    nocorrect?: boolean;
    /** Flag to set DOM attribute autoCapitalize="off" */
    nocapitalize?: boolean;

    /** Value change handler - the only way to get the value of the input */
    onChange: (e: any) => void;
    value?: string;
}

const TextInput = (props: Props) => {
    const inputProps: any = {
        name: props.name,
        type: props.type || "text",
        defaultValue: props.defaultValue,
        placeholder: props.placeholder,
        disabled: props.disabled,
        required: props.required,
        onChange: props.onChange,
        autoComplete: props.nocomplete ? "off" : undefined,
        autoCorrect: props.nocorrect ? "off" : undefined,
        autoCapitalize: props.nocapitalize ? "off" : undefined,
    };
    if (props.value) {
        inputProps.value = props.value;
    }

    return (
        <>
            <input id={props.name} className={styles["text-input"]} key={`${props.name}_input`} {...inputProps} />
            <label className={styles["text-input-label"]} key={`${props.name}_label`} htmlFor={props.name}>
                {props.help}
            </label>
        </>
    );
};

export default TextInput;
